import { useAuthTokensRefreshData } from '../../contexts/AuthContext';
import { useUserData } from '../../contexts/UserContext';

export const useIsLoggingIn = (): boolean => {
  const { isTokenValid } = useAuthTokensRefreshData();
  const { user, isLoading } = useUserData();

  const hasAllUserData = !isLoading && !!user;

  return isTokenValid && !hasAllUserData;
};
